import React, {Component} from 'react';
import {Link} from 'react-router';

export default class DriverProfile extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row">
                <div className="alert alert-info">
                    <ol>
                        <li>Zaregistruj sa</li>
                        <li>Vyplň formulár</li>
                        <li>Ozveme sa Ti ešte dnes!</li>
                    </ol>
                </div>
                <Link to="/register">
                    <button className="btn btn-primary btn-lg">Registrácia</button>
                </Link>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/components/index_home.jsx